/**
 * Transaction Complete Stamp - Shows diagonal "COMPLETED" or "APPROVED" stamp overlay
 * Design inspired by official stamp with stars and checkmark
 */

import { Check } from "lucide-react";

const STARS = ["s1", "s2", "s3", "s4", "s5"];

export default function TransactionStamp({ isComplete, paymentMethod }) {
  if (!isComplete) return null;
  
  const stampText = paymentMethod === 'cash' ? 'COMPLETED' : 'APPROVED';
  
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-20 bg-white/40">
      <div 
        className="flex items-center gap-4"
        style={{
          transform: 'rotate(-45deg)',
          opacity: 0.35,
        }}
      >
        {/* Main Stamp */}
        <div className="relative">
          {/* Outer border with rounded corners */}
          <div 
            className="border-[6px] border-green-500 rounded-xl px-8 py-4 bg-white/90"
            style={{
              boxShadow: 'inset 0 0 0 3px white, inset 0 0 0 6px #22c55e',
            }}
          >
            {/* Stars row top */}
            <div className="flex justify-center gap-1 mb-1">
              {STARS.map((s) => (
                <span key={`top-${s}`} className="text-green-500 text-xs">★</span>
              ))}
            </div>
            
            {/* Main text */}
            <div 
              className="text-5xl font-black text-green-500 tracking-wider"
              style={{
                textShadow: '2px 2px 0 rgba(34, 197, 94, 0.3)',
                fontFamily: 'Arial Black, sans-serif',
              }}
            >
              {stampText}
            </div>
            
            {/* Stars row bottom */}
            <div className="flex justify-center gap-1 mt-1">
              {STARS.map((s) => (
                <span key={`bottom-${s}`} className="text-green-500 text-xs">★</span>
              ))}
            </div>
          </div>
        </div>
        
        {/* Large Checkmark */}
        <div className="text-green-500">
          <Check 
            className="w-24 h-24" 
            strokeWidth={4}
            style={{
              filter: 'drop-shadow(3px 3px 2px rgba(0,0,0,0.1))',
            }}
          />
        </div>
      </div>
    </div>
  );
}

